import { useController, UseControllerProps } from 'react-hook-form'
import cl from 'clsx'

import { Input2 } from '@/shared/ui'

import classes from './ContragentModal.module.scss'
import { FormValues, isFieldRequired, ContragentType } from './form/schema'

type PassportFieldProps = Omit<UseControllerProps<FormValues>, 'name'> & {
    type: ContragentType
    name: 'passport'
    label: string
    roleType?: 'publisher' | 'advertiser' | 'agency' | 'ors'
}

// Форматирует ввод паспорта: "1234567890" -> "1234 567890"
const formatPassport = (value: string): string => {
    // Убираем все нецифровые символы
    const digits = value.replace(/\D/g, '')

    // Ограничиваем до 10 цифр (4 серия + 6 номер)
    const limited = digits.slice(0, 10)

    // Добавляем пробел после 4 цифр серии
    if (limited.length > 4) {
        return `${limited.slice(0, 4)} ${limited.slice(4)}`
    }

    return limited
}

export const PassportField = ({
    label,
    type,
    roleType,
    ...controllerProps
}: PassportFieldProps) => {
    const { field, fieldState, formState } = useController(controllerProps)
    const { name } = controllerProps

    const required = isFieldRequired(type, name, roleType)

    const handleChange = (value: string) => {
        const formatted = formatPassport(value)
        field.onChange(formatted)
    }

    return (
        <label
            className={cl(classes.textField, {
                [classes.required]: required,
            })}
        >
            <div className={classes.label}>{label}</div>
            <Input2
                name={field.name}
                value={field.value}
                onChange={handleChange}
                onBlur={field.onBlur}
                disabled={formState.isSubmitting}
                placeholder="1234 567890"
                inputClassName={cl(fieldState.error ? 'border-red-500' : '')}
            />
            {fieldState.error?.message && (
                <div className="text-[10px] text-red-500">
                    {fieldState.error.message}
                </div>
            )}
        </label>
    )
}
